module.exports = __webpack_public_path__ + "img/flower-xu.8bdf2462.jpg";